import { createBrowserRouter, redirect } from 'react-router-dom'
import PageLayout from 'src/layout/PageLayout'

import ExplorerDelete from 'src/views/Service/Explorer/Delete'
import Explorer from 'src/views/Service/Explorer/Main'
import Setting from 'src/views/Service/Setting'
import LoginPage from 'src/views/Account/Login'
import CameraPage from 'src/views/Service/Camera'
import ResetPage from 'src/views/Account/Reset'
import HomePage from 'src/views/Service/Home'
import LocationPage from 'src/views/Service/Location'
import LocationDetail from 'src/views/Service/Location/LocationDetail'
import ExplorerDetailPage from 'src/views/Service/Explorer/Detail'
import AccountPage from 'src/views/Account'
import ServicePage from 'src/views/Service'

const routes = [
  {
    element: <AccountPage />,
    children: [
      { path: '', element: <LoginPage /> },
      { path: 'reset', element: <ResetPage /> },
    ],
  },
  {
    element: <ServicePage />,
    children: [
      { path: 'home', element: <HomePage /> },

      { path: 'location', element: <LocationPage /> },
      { path: 'location/detail/:idx', element: <LocationDetail /> },

      { path: 'explorer', element: <Explorer /> },
      { path: 'explorer/detail/:fileType', element: <ExplorerDetailPage /> },
      { path: 'explorer/delete', element: <ExplorerDelete /> },

      { path: 'camera', element: <CameraPage /> },
      { path: 'setting', element: <Setting /> },
    ],
  },
]

const pageLayout = <PageLayout />

export const router = createBrowserRouter([
  {
    element: pageLayout,
    children: routes,
  },
  {
    path: '*',
    loader: async () => {
      return redirect('/')
    },
  },
])
